import { types } from "../types/types";


export const closeNavbar = () => ({ type: types.uiCloseNavbar })

export const toggleNavbar = () => ({ type: types.uiToggleNavbar })

export const toggleSelectImage = () => ({ type: types.uiToggleSelectImage })

export const showSpinner = () => ({ type: types.uiShowSpinner })

export const hideSpinner = () => ({ type: types.uiHideSpinner })


